import React, {useEffect, useState} from "react";
import { makeStyles, withStyles } from "@material-ui/core/styles";
import {
    Grid,
    TextField,
    FormControlLabel,
    Checkbox,
    Tooltip,
} from "@material-ui/core";
import { green } from "@material-ui/core/colors";
import { localStorageFunc, maskedNumber } from "../../../../helpers/utility";

const GreenCheckbox = withStyles({
    root: {
        color: green[400],
        "&$checked": {
            color: green[600],
        },
    },
    checked: {},
})((props) => <Checkbox color="default" {...props} />);

const useStyles = makeStyles((theme) => ({
    root: {
        "& .MuiTextField-root": {
            margin: theme.spacing(1),
            //   width: 200,
        },
    },
    grid: {
        // padding: "0 !important",
    },
    
    label: {
        padding: "0",
        width: "100%",
        fontFamily: "Lato",
        fontStyle: "normal",
        fontWeight: "bold",
        fontSize: "14px",
        lineHeight: "18px",
        letterSpacing: "0.5px",
        color: "#686D88",
    },
    textfield: {
        fontFamily: "Lato",
        fontStyle: "normal",
        fontWeight: "400",
        fontSize: "14px",
        lineHeight: "22px",
        color: "#343A58",
        border: "1px solid #686D88",
        boxSizing: "border-box",
        borderRadius: "4px",
        margin: "8px 0 !important",
    },
    CancelButton: {
        margin: "5px",
        backgroundColor: "white",
        border: "1px solid blue",
        textTransform: "capitalize",
    },
    UpdateButton: {
        height: "41px",
        margin: "5px",
        textTransform: "capitalize",
    },
    Buttons: {
        display: "flex",
        flexDirection: "row reverse ",
        flex: "1",
        justifyContent: "flex-end",
    },
}));

function ShowCustomerDetails(props) {
    const classes = useStyles();
    let crmValues = props.crmValues;
    const [abc, setAbc] = useState({});

useEffect(() => {
    try {
      const storedData = localStorageFunc.get("crmValues");
      setAbc(storedData ? JSON.parse(storedData) : {});
    } catch (error) {
      console.error("Error parsing localStorage data:", error);
      setAbc({});
    }
  }, [props.crmValues, props.basicValues]);

    return (
        <Grid container spacing={1}>
            {props.group.length &&
                props.group.map((arrItem, index) => {
                    if (arrItem.type === "select") {
                        return (
                            <Grid
                                container
                                className={classes.grid}
                                key={index}
                                item
                                md={4}
                                xs={12}
                                lg={4}
                            >
                               <label className={classes.label}>
                                {arrItem.label}
                                {arrItem.mandatory && <span className="mandatory-point" style={{ color: 'red' }}>*</span>}  
                            </label>
                               
                                <Tooltip
                                    title={crmValues[arrItem.name] !== ""
                                    ? crmValues[arrItem.name]
                                    : "N/A"}>
                                    <TextField
                                        fullWidth
                                        className=""
                                        id = {arrItem.name}
                                        margin="dense"
                                        name={arrItem.name}
                                        required
                                        value={crmValues[arrItem.name] !== ""
                                        ? abc[arrItem.name] ||crmValues[arrItem.name]
                                        : "N/A"}
                                        variant="outlined"
                                        disabled
                                    />
                                </Tooltip>
                            </Grid>
                        );
                    }
                    if (arrItem.type === "checkbox") {
                        return (
                            <FormControlLabel
                                key={index}
                                control={
                                    <GreenCheckbox
                                        checked={crmValues.checked}
                                        onChange={(event) =>
                                            props.handleChange(event)
                                        }
                                        value={abc[arrItem.name] || crmValues[arrItem.name]}
                                    />
                                }
                                label={arrItem.label}
                            />
                        );
                    }
                
                    return (
                        <Grid
  container
  className={classes.grid}
  key={index}
  item
  md={4}
  xs={12}
  lg={4}
>
  <label className={classes.label}>
    {arrItem.label}
    {arrItem.mandatory && (
      <span className="mandatory-point" style={{ color: "red" }}>
        *
      </span>
    )}
  </label>

  <Tooltip
    title={
      crmValues[arrItem.name] !== null && crmValues[arrItem.name] !== ""
        ? crmValues[arrItem.name]
        : "N/A"
    }
  >
    <TextField
      fullWidth
      margin="dense"
      id={arrItem.name}
      name={arrItem.name}
      required
      value={(() => {
        const val =
          abc[arrItem.name] ||
          crmValues[arrItem.name] ||
          "N/A";

        if (
          props.facilityConf.enable_number_mask === "1" &&
          /phone\d*/i.test(arrItem.name) &&
          val !== "N/A"
        ) {
          // Use your existing masking function
          return maskedNumber(
            val,
            props.facilityConf.mask_start_pos,
            props.facilityConf.mask_end_pos
          );
        }

        return val;
      })()}
      variant="outlined"
      disabled
    />
  </Tooltip>
</Grid>
                    );
                })}
        </Grid>
    );
}
export default ShowCustomerDetails;
